/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-06-18 13:33:36
 * @LastEditors: hongye
 * @LastEditTime: 2025-12-19 18:03:41
 * @Description: file content
 */
import { defineStore } from 'pinia'
export interface TabIn {
  name: string
  path: string
  meta: any
}

export interface TabParams {
  serviceSiteCode: string
  startTime: string
  endTime: string
}

export const useTabStore = defineStore('tabs', {
  state: () => ({
    tabList: [] as TabIn[],
    tabsParams: {} as TabParams
  }),
  getters: {
    getTabs: (state) => state.tabList,
    getTabsParams: (state) => state.tabsParams
  },
  actions: {
    setTabs(menuItem: TabIn) {
      //白名单数组
      const whiteListArray = ['/notFound', '/noAuth','/login']
      if (whiteListArray.includes(menuItem.path)) return
      const findItem = this.tabList.some((_) => _.path === menuItem.path)
      if (!findItem) {
        this.tabList.push(menuItem)
      } else {
        const findItemIndex = this.tabList.findIndex((_) => _.path === menuItem.path)
        this.tabList[findItemIndex] = menuItem
      }
    },
    setTabsParams(params: TabParams) {
      this.tabsParams = params
    },
    delTabs(path: string) {
      const index = this.tabList.findIndex((_) => _.path === path)
      this.tabList.splice(index, 1)
    },
    /**
     * 从 tabList 数组中移除匹配的标签      
     * @param path - 用于匹配标签路径的字符串
     * @param isPath - 可选参数，布尔类型。为 true 时进行精确匹配，为 false 或未传入时进行模糊匹配，默认为 false
     */
    removeTag(path: string, isPath?: boolean) {
      if(isPath) {
        this.tabList = this.tabList.filter((_) => _.path !== path)
        return
      }
      this.tabList = this.tabList.filter((_) => !_.path.includes(path))
    }
  },
  persist: {
    storage: localStorage
  }
})
